import React from "react";

import { IViewProps, View } from "core/decorators/View";
import Label from "core/components/label/Label";
import { SeparatorView } from "common/views/separator/Separator.view";
import { BoxView } from "common/views/box/Box.view";

interface CreditSummaryProps extends IViewProps<string>{
	blockData?: any,
}
export class CreditSummaryView<D, T> extends React.Component<CreditSummaryProps> {

	public render() {
		const { blockData } = this.props;

		return (
			<React.Fragment>
				<BoxView viewKey="creditEarnedBox">
					<div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px" }}>
						{blockData.map((i) => {
							return (
								<React.Fragment>
									<div><Label k={i.title} v={i.title} /></div>
									<div>{i.value}</div>
								</React.Fragment>
							)}
						)}
					</div>
				</BoxView>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/creditSummary/CreditSummaryView.tsx